import { UserInfoToPatch } from './types';
import { UserInfo } from 'types/entities/UserInfo';

export function mapUserInfoToSnakeCase(
  patch: UserInfoToPatch,
): Partial<UserInfo> {
  const snakeCasePatch: Partial<UserInfo> = {};

  if (patch.hasOwnProperty('firstName')) {
    snakeCasePatch.first_name = patch.firstName;
  }
  if (patch.hasOwnProperty('lastName')) {
    snakeCasePatch.last_name = patch.lastName;
  }
  if (patch.hasOwnProperty('companyName')) {
    snakeCasePatch.company_name = patch.companyName;
  }
  if (patch.hasOwnProperty('phoneNumber')) {
    snakeCasePatch.phone_number = patch.phoneNumber;
  }

  return snakeCasePatch;
}
